exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-select-input {\n  width: 100% !important;\n  left: 0 !important;\n  /* 确保下拉框和筛选框的左边对齐 */\n}\n.iv-select-dropdown {\n  width: 100% !important;\n  text-align: left !important;\n}\n", ""]);

// exports
